import React from 'react'
import { useSelector } from 'react-redux'
import Card from 'transfix-ui/components/Card'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { ICarrierState } from 'types'
import { IStore } from 'apps/carrier/utils/reducers'
import { INLINE_MESSAGE_VARIANTS, InlineMessage } from 'transfix-ui'
import { ValueField } from '../..'
import { DataReportedBy } from '../../DataReportedBy'
import { useStatsSummaryQuery } from './graphql/StatsSummary'

export const StatsSummary = () => {
  const { carrierDetails } = useSelector<IStore, ICarrierState>(({ carrier }) => carrier)
  const { id: carrierId = '' } = carrierDetails || {}

  const { data, error, loading } = useStatsSummaryQuery({
    variables: {
      carrierApplicationId: carrierId,
    },
  })

  const { highwayCarrier } = data || {}
  const { brokerAuthority, driverOosInspections, fatalCrashes, injuryCrashes, updatedAt } =
    highwayCarrier || {}

  return (
    <Card>
      <Box display='grid' gap='12px'>
        <div>
          <Typography variant='h3'>Status Summary</Typography>
          <DataReportedBy reporter='highway' date={updatedAt} />
        </div>
        {error && <InlineMessage type={INLINE_MESSAGE_VARIANTS.ALERT} message={error.message} />}
        <ValueField title='Driver OOS' value={driverOosInspections} loading={loading} percent />
        <ValueField title='Broker Authority' value={brokerAuthority} loading={loading} />
        <ValueField title='Fatal Crashes' value={fatalCrashes} loading={loading} />
        <ValueField title='Injury Crashes' value={injuryCrashes} loading={loading} />
      </Box>
    </Card>
  )
}

export default StatsSummary
